import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
const IMPORT_PROPOSALS_FORM_URL = 'https://forms.gle/Q9sMHXFcp5Fs866FA';
function ImportProposalsContent(param) {
    let { texts } = param;
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: texts.intro()
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                children: [
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        openInNewTab: true,
                        href: IMPORT_PROPOSALS_FORM_URL,
                        bi: {
                            name: 'import_proposals_complete_form'
                        },
                        children: texts.completeForm()
                    }),
                    ' ',
                    texts.outro()
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                children: texts.note()
            })
        ]
    });
}
function ImportProposalsModal(param) {
    let { dismissModal, texts, closeButtonTestId } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'proposals_confirm'
            },
            secondaryButton: {
                name: 'proposals_cancel'
            }
        },
        textAlignCenter: false,
        primaryButtonLabel: texts.close(),
        onPrimaryButtonClick: ()=>dismissModal(),
        onCloseButtonClick: ()=>dismissModal(),
        title: texts.title(),
        primaryButtonTestId: closeButtonTestId,
        content: /*#__PURE__*/ _jsx(ImportProposalsContent, {
            texts: texts
        })
    });
}
export const importProposalsModalConfig = (param)=>{
    let { texts, closeButtonTestId } = param;
    return {
        biName: 'proposals_dashboard_import_modal_confirm',
        content: (props)=>/*#__PURE__*/ _jsx(ImportProposalsModal, _object_spread_props(_object_spread({}, props), {
                texts: texts,
                closeButtonTestId: closeButtonTestId
            }))
    };
};
